<div *ngIf="isBlockedPage" class="atp-preloader-container"
  [class.atp-preloader-container_transparent]="!isPreloaderShow">
  <mat-spinner *ngIf="isPreloaderShow"></mat-spinner>
</div>

<atp-title class="atp-dynamic-form__title" text="Восстановление пароля" notSetInHeader="false">
</atp-title>

<form *ngIf="emailFormGroup" [formGroup]="emailFormGroup" (ngSubmit)="emailFormSubmit()" novalidate>
  <p>Укажите свой email, под которым вы зарегистрированы на сайте и на него будет отправлена информация о восстановлении
    пароля.</p>
  <br>
  <mat-form-field class="form-field_full-width">
    <input type="email" matInput placeholder="Email" name="login" formControlName="login" required>
    <mat-error *ngIf="loginErrorLabel">{{loginErrorLabel}}</mat-error>
  </mat-form-field>
  <br>
  <br>
  <button mat-raised-button [disabled]="emailFormGroup.invalid" color="primary" type="submit">Отправить</button>
</form>

<form *ngIf="changePasswordFormGroup" [formGroup]="changePasswordFormGroup" (ngSubmit)="changePasswordFormSubmit()"
  novalidate>
  <p>Введите новый пароль и подтверждение.</p>
  <br>
  <mat-form-field class="form-field_full-width">
    <input type="password" matInput placeholder="Новый пароль" name="password" formControlName="password" required>
    <mat-error *ngIf="passwordErrorLabel">{{passwordErrorLabel}}</mat-error>
  </mat-form-field>
  <br>
  <mat-form-field class="form-field_full-width">
    <input type="password" matInput placeholder="Подтверждение пароля" name="confirmPassword"
      formControlName="confirmPassword" required>
    <mat-error *ngIf="confirmPasswordErrorLabel">{{confirmPasswordErrorLabel}}</mat-error>
  </mat-form-field>
  <br>
  <br>
  <button mat-raised-button [disabled]="changePasswordFormGroup.invalid" color="primary" type="submit">Изменить
    пароль</button>
</form>

<div *ngIf="!emailFormGroup && !changePasswordFormGroup">
  <p>Письмо с дальнейшими инструкциями отправлено на указанный email</p>
</div>